import "./BiomarkerBasicDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import BiomarkerBasicDetailsViewComponent from "./biomarker-basic-details-view/BiomarkerBasicDetailsViewComponent";
import BiomarkerBasicDetailsEditComponent from "./biomarker-basic-details-edit/BiomarkerBasicDetailsEditComponent";

interface BiomarkerBasicDetailsViewEditComponentProps {
    biomarkerDetails?: any;
    canEdit?: boolean;
    onModeChange: (mode: string) => void;
    onUpdateBiomarkerDetails: (biomarkerDetails: any) => void;
}

const BiomarkerBasicDetailsViewEditComponent = (props: BiomarkerBasicDetailsViewEditComponentProps) => {
    const {biomarkerDetails, canEdit, onModeChange, onUpdateBiomarkerDetails} = props;

    useEffect((biomarkerDetails?: any) => {
        if (biomarkerDetails) {
            setBiomarkerBasicDetails(biomarkerDetails?.adminDetails);
        }
    }, [biomarkerDetails]);

    const [mode, setMode] = useState<"view" | "edit">("view");
    const [biomarkerBasicDetails, setBiomarkerBasicDetails] = useState<any>(undefined);

    const handleBiomarkerBasicDetailsDetailsUpdate = useCallback((updatedBiomarkerDetailsDetails: any) => {
        onUpdateBiomarkerDetails(updatedBiomarkerDetailsDetails);
        setMode("view");
    }, [onUpdateBiomarkerDetails]);

    const handleBiomarkerDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (biomarkerDetails) {
            setBiomarkerBasicDetails(biomarkerDetails);
        }
    }, [biomarkerDetails]);

    useEffect(() => {
        onModeChange(mode);
    }, [mode, onModeChange])

    return (
        <div className={'biomarker-basic-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <BiomarkerBasicDetailsViewComponent
                    biomarkerBasicDetails={biomarkerBasicDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <BiomarkerBasicDetailsEditComponent
                    biomarkerBasicDetails={biomarkerBasicDetails}
                    onUpdateComplete={handleBiomarkerBasicDetailsDetailsUpdate}
                    onEditCancel={handleBiomarkerDetailsEditCancel}
                />
            }
        </div>
    );

};

export default BiomarkerBasicDetailsViewEditComponent;